<section class="main cmargin" style="padding-bottom:0px">
    <div class="container privacy">
        <div class="row">
            <div class="col-md-12">
                <div class="title11">
                    <h1 style="margin-top:0px">Privacy Policy</h1>
                    <p>
                        You hereby consent and agree that you have read and fully understood the Privacy Policy of
                        the Website.
                    </p>
                    <p>
                        The user further consents that the terms and contents of such Privacy Policy are acceptable
                        to him.
                    </p>
                    <p>
                        This Privacy Policy governs the manner in which HOME FABRICS collects, uses, maintains and
                        discloses information collected from users (each, a "User") of the homefabricsindia.com
                        website ("Site"). This privacy policy applies to the Site and all products and services
                        offered by HOME FABRICS. It will notify users (each, a “User”) of the following:
                    </p>

                    <ol>
                        <li>What personally identifiable information is collected from you through the web site and
                            how it is used and with whom it may be shared.</li>
                        <li>
                            What choices are available to you regarding the use of your data.
                        </li>
                        <li>
                            The security procedures in place to protect the misuse of your information.
                        </li>
                        <li>
                            How you can correct any inaccuracies in the information.
                        </li>
                    </ol>
                    <p>
                        This privacy policy applies to the Site and all products and services offered by HOME
                        FABRICS
                    </p>
                </div>
                <div class="title">
                    <h1>What information do we collect?</h1>
                    <ul>
                        <li>We collect information from you when you register on the site, place an order, enter a
                            contest or sweepstakes, respond to a survey or communication such as e-mail, or
                            participate in another site feature.
                        </li>
                        <li>Like many websites, we use "cookies" to enhance your experience and gather information
                            about visitors and visits to our websites. Please refer to the <b>"Do we use 'cookies'?"</b>
                            section below for information about cookies and how we use them.
                        </li>
                    </ul>
                </div>
                <div class="title">
                    <h1>How do we protect visitor information?</h1>
                    <p>We implement a variety of security measures to maintain the safety of your personal
                        information. Your personal information is contained behind secured networks and is only
                        accessible by a limited number of persons who have special access rights to such systems,
                        and are required to keep the information confidential. When you place orders or access your
                        personal information, we offer the use of a secure server. All sensitive/credit information
                        you supply is transmitted via Secure Socket Layer (SSL) technology and then encrypted into
                        our databases to be only accessed as stated above.</p>
                    <p class="mb-0">
                        <b>Do we use "cookies"?</b>
                    </p>
                    <p>
                        Yes. Cookies are small files that a site or its service provider transfers to your
                        computer's hard drive through your Web browser (if you allow) that enables the site's or
                        service provider's systems to recognize your browser and capture and remember certain
                        information. For instance, we use cookies to help us remember and process the items in your
                        shopping cart. They are also used to help us understand your preferences based on previous
                        or current site activity, which enables us to provide you with improved services. We also
                        use cookies to help us compile aggregate data about site traffic and site interaction so
                        that we can offer better site experiences and tools in the future.
                    </p>
                    <p>We may contract with third-party service providers to assist us in better understanding our
                        site visitors. These service providers are not permitted to use the information collected on
                        our behalf except to help us conduct and improve our business.
                    </p>
                    <p>
                        You can choose to have your computer warn you each time a cookie is being sent, or you can
                        choose to turn off all cookies. You do this through your browser (like Netscape Navigator or
                        Internet Explorer) settings. Each browser is a little different, so look at your browser
                        Help menu to learn the correct way to modify your cookies. If you turn cookies off, you
                        won't have access to many features that make your site experience more efficient and some of
                        our services will not function properly. However, you can still place orders over the
                        telephone by contacting customer service.

                    </p>
                    <p>HOME FABRICS is the sole owner of the information collected on this site. The only
                        information HOME FABRICS has access to collect is information that was voluntarily given
                        when registering in the Site such as; name, address, phone and billing information via email
                        or other direct contact from you. HOME FABRICS will not sell or rent this information to
                        anyone.
                    </p>
                    <p>
                        HOME FABRICS will use your information to respond to you, regarding the reason you contacted
                        us. HOME FABRICS will not share your information with any third party outside of the
                        organization, other than as necessary to fulfill the request of the User, e.g. to ship an
                        order.
                    </p>
                    <p>
                        The email address Users provide for order processing, will only be used to send them
                        information and updates pertaining to their order. It may also be used to respond to their
                        inquiries, and/or other requests or questions. If User decides to opt-in to our mailing
                        list, they will receive emails that may include company news, updates, related product or
                        service information, etc. If at any time the User would like to unsubscribe from receiving
                        future emails, we include detailed unsubscribe instructions at the bottom of each email or
                        User may contact us via our Site.

                    </p>
                    <p class="mb-0">
                        <b> Do we disclose the information we collect to outside parties?</b>
                    </p>
                    <p>
                        We do not sell, trade, or otherwise transfer to outside parties your personally identifiable
                        information unless we provide you with advance notice, except as described below. The term
                        "outside parties" does not include HOME FABRICS. It also does not include website hosting
                        partners and other parties who assist us in operating our website, conducting our business,
                        or servicing you, so long as those parties agree to keep this information confidential. We
                        may also release your information when we believe release is appropriate to comply with the
                        law, enforce our site policies, or protect ours or others' rights, property, or safety.

                    </p>
                    <p>
                        However, non-personally identifiable visitor information may be provided to other parties
                        for marketing, advertising, or other uses.

                    </p>
                    <p class="mb-0">
                        <b>How can you opt-out, remove or modify information you have provided to us?</b>
                    </p>
                    <p>
                        To modify your e-mail subscriptions, please let us know by modifying your preferences in the
                        "My Account" section. Please note that due to email production schedules you may receive any
                        emails already in production.

                    </p>
                    <p>
                        To delete all of your online account information from our database, sign into the "My
                        Account" section of our site and remove your shipping addresses, billing addresses & payment
                        information. Please note that we may maintain information about an individual sales
                        transaction in order to service that transaction and for record keeping.

                    </p>

                </div>
                <div class="title">
                    <h1> Third party links</h1>
                    <p>
                        In an attempt to provide you with increased value, we may include third party links on our
                        site. These linked sites have separate and independent privacy policies. We therefore have
                        no responsibility or liability for the content and activities of these linked sites.
                        Nonetheless, we seek to protect the integrity of our site and welcome any feedback about
                        these linked sites (including if a specific link does not work).
                    </p>
                </div>

                <div class="title">
                    <h1> Changes to our policy</h1>
                    <p>
                        If we decide to change our privacy policy, we will post those changes on this page. Policy
                        changes will apply only to information collected after the date of the change. This policy was
                        last modified on March 1st, 2021.
                    </p>
                </div>

                <div class="title">
                    <h1> Questions and feedback</h1>
                    <p>
                        We welcome your questions, comments, and concerns about privacy. Please send us any and all
                        feedback pertaining to privacy, or any other issue.
                    </p>
                </div>

                <div class="title">
                    <h1>Online Policy Only</h1>
                    <p>
                        This online privacy policy applies only to information collected through our website and not to
                        information collected offline.
                    </p>
                </div>

                <div class="title">
                    <h1> <a routerLink="/termsCondition">Terms and Conditions</a></h1>
                    <p>
                        Please also visit our Terms and Conditions section establishing the use, disclaimers, and
                        limitations of liability governing the use of our website.
                    </p>
                </div>

                <div class="title">
                    <h1>Your consent </h1>
                    <p>
                        By using our site, you consent to our privacy policy
                    </p>
                </div>

                <div class="title">
                    <h1><a routerLink="">Contacting us</a></h1>
                    <p>
                        If you have any questions about this Privacy Policy, the practices of this site, or your
                        dealings with this site, please contact us.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
